import { useHotelDynamicDetails, useStepButtonsPortal } from "../../context";
import { usePriceBreakdown } from "src/Modules/Hotels/hooks/usePriceBreakdown";
import HotelSidebar from "./HotelSidebar";
import { MobileBottomDrawer } from "src/Modules/Hotels/Components";
import { useTranslation } from "react-i18next";

export default function MobileSidebarDrawer() {
  const { t } = useTranslation();
  const { setPortalContainer } = useStepButtonsPortal();
  const { hotel, selectedRoom, pointsFactor } = useHotelDynamicDetails();

  // No paymentState passed here on purpose: this strip always shows the room's constant
  // full value, regardless of any points selection made on the Payment step.
  const price = usePriceBreakdown({ hotel, selectedRoom, pointsFactor });

  const barContent = (
    <>
      <div className="flex items-center justify-between px-4 md:py-3 py-2">
        <span className="text-font-subtle uppercase text-xs font-semibold tracking-wide">{t("Flights.details.summary.totalAmount")}</span>
        <div className="flex gap-2 items-center font-semibold text-sm">
          <span className="text-font-default">{price.formattedTotalCash}</span>
          <span className="border border-dashed border-border-disabled rounded-full h-6 w-6 flex items-center justify-center text-xs leading-1 text-font-default">
            {t("Flights.details.summary.or")}
          </span>
          <span className="text-font-active font-bold">{price.formattedTotalPoints}</span>
        </div>
      </div>
      <div className="px-5" ref={setPortalContainer} />
    </>
  );

  return <MobileBottomDrawer title={t("Hotels.booking.checkoutSummary")} barContent={barContent} drawerContent={<HotelSidebar />} />;
}
